<template>
  <div class="hotel-details-modal-component" v-if="hotel">
    <v-dialog
      v-model="dialog"
      scrollable
      attach=".hotel-details-modal-component"
    >
      <v-card>
        <div class="flex justify-between items-center space-x-5 mb-8">
          <div
            class="
              go-back
              flex grow-0
              items-center
              space-x-2
              font-bold
              cursor-pointer
            "
            @click.stop="close"
          >
            <v-icon color="black">mdi-chevron-left</v-icon>
            <v-card-title>{{$t("hotel.go_back")}}</v-card-title>
          </div>
          <v-icon class="close" color="black" @click.stop="close"
            >mdi-close</v-icon
          >
        </div>

        <v-card-text>
          <div class="hotel-info-container">
            <div class="img-container-outer mb-8">
              <div class="img-container-inner">
                <v-carousel hide-delimiters max="5" cycle interval="5000">
                  <v-carousel-item
                    v-for="(item, i) in hotel.images"
                    :key="i"
                    eager
                  >
                    <v-img
                      lazy-src="/img/no-image-placeholder.jpg"
                      :src="baseImg(item.path)"
                      eager
                    ></v-img>
                  </v-carousel-item>
                </v-carousel>
              </div>
            </div>

            <div class="section pb-4">
              <!-- <tripadvisor-score class="mb-2"></tripadvisor-score> -->
              <tripadvisor-score
                v-if="hotel.reviews"
                :rating="hotel.reviews[0].rate"
              ></tripadvisor-score>
              <div class="flex space-x-4 items-center mb-4">
                <p class="name font-bold">{{ hotel.name }}</p>
                <hotel-category
                  :category-code="hotel.categoryCode"
                ></hotel-category>
              </div>
              <div class="flex items-center space-x-2">
                <img src="/img/icons/map_marker.svg" />
                <span>{{ hotel.distance }} {{$t("hotel.km_center")}}</span>
              </div>
            </div>

            <div class="section">
              <p class="font-black mb-1">{{$tc("hotel.room", 1)}}</p>
              <p>{{$t("hotel.double_standard")}}</p>
            </div>
            <div class="section lg:flex lg:space-x-12 xl:space-x-20">
              <div class="lg:w-1/2">
                <p class="font-black mb-1">{{$t("hotel.description")}}</p>
                <p class="mb-4">{{ hotel.description }}</p>
              </div>
              <div class="lg:w-1/2">
                <p class="font-black mb-2">{{$t("hotel.services")}}</p>
                <div class="facilities">
                  <p
                    v-for="(facility, idx) in hotel.facilities"
                    :key="idx"
                    class="mb-2"
                  >
                    {{ `${facility.description.content}` }}
                  </p>
                </div>
              </div>
            </div>
            <div class="section">
              <p class="font-black mb-2">{{$t("hotel.location")}}</p>
              <div class="lg:flex lg:space-x-12 lg:items-start xl:space-x-20">
                <div class="map-container">
                  <hotel-map :hotel="hotel" :dialog-is-open="open"></hotel-map>
                </div>
                <div class="lg:w-1/2">
                  <p class="font-black mb-6 flex items-center space-x-4">
                    <img src="/img/icons/map_marker_2.svg" />
                    <a :href="addressMapLink" target="_blank" class="underline"
                      >{{ hotel.address }}, {{ hotel.postalCode }}</a
                    >
                  </p>
                  <!-- <p class="font-black flex items-center space-x-4">
                    <img src="/img/icons/phone.svg">
                    <span>{{ phone }}</span>
                  </p> -->
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import HotelCategory from "../common/HotelCategory.vue";
import TripadvisorScore from "./TripadvisorScore.vue";
import HotelMap from "./HotelMap.vue";

const imgRoots = {
  xl: "http://photos.hotelbeds.com/giata/xl/",
  large: "http://photos.hotelbeds.com/giata/bigger/",
};

export default {
  props: {
    open: {
      type: Boolean,
    },
    hotel: {
      required: true,
      validator: (prop) => typeof prop === "object" || prop === null,
    },
  },
  components: { HotelCategory, HotelMap, TripadvisorScore },
  data() {
    return {
      dialog: false,
      imgRoot: imgRoots.large,
    };
  },
  computed: {
    phone() {
      return this.hotel.phones.find(
        ({ phoneType }) => phoneType === "PHONEHOTEL"
      ).phoneNumber;
    },
    addressMapLink() {
      let { address, postalCode, destinationName, latitude, longitude } =
        this.hotel;
      address = address.replace(/\s/g, "+");
      destinationName = destinationName.replace(/\s/g, "+");
      return `https://www.google.com/maps/place/${address},+${postalCode}+${destinationName}/@${latitude},${longitude}`;
    },
  },
  watch: {
    open(open) {
      this.dialog = open;
    },
    dialog(open) {
      //  document.body.classList[open ? 'add' : 'remove']('overflow-hidden');
      //  document.body.style.height = open ? '100vh' : 'auto';
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("close");
    },
    baseImg(src) {
      return `${this.imgRoot}${src}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.hotel-details-modal-component::v-deep {
  .v-dialog__content {
    z-index: 2001 !important;
  }

  .v-card__text {
    @media (max-width: 768px) {
      padding: 0 !important;
    }
  }

  //Scrollbar customized
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #00adbc;
  }
  ///////

  .v-dialog {
    width: 100% !important;
    height: 100vh !important;
    margin: 0 !important;
    max-height: none !important;

    @media (min-width: 1024px) {
      max-height: 90% !important;
      max-width: 90% !important;
      border-radius: 15px;
    }
    @media (min-width: 1280px) {
      width: 1114px !important;
      height: auto !important;
    }

    .v-card {
      // overflow-y: auto;
      background-color: white;
      cursor: default;
    }
  }
}
.hotel-info-container {
  height: 100%;
  overflow-y: scroll;

  @media (max-width: 768px) {
    padding: 0.6rem;
  }

  @media (min-width: 1280px) {
    overflow-y: auto;
  }
}
.avm-btn {
  width: 8.5rem !important;
  min-width: unset !important;

  @media (min-width: 1440px) {
    width: 10rem !important;
  }
}
.v-card {
  padding: 24px 10px;

  @media (min-width: 1024px) {
    padding: 2.5rem;
    border-radius: 15px;
  }

  .go-back {
    color: black;
  }

  .close {
    @media (min-width: 1024px) {
      font-size: 40px;
    }
  }

  .img-container-outer {
    width: 100%;
    position: relative;
    // paddikng-top: 63.66%;

    @media (min-width: 768px) {
      // padding-top: 41.43%;
    }

    .img-container-inner {
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 15px;
      }
    }
  }

  .name {
    font-size: 25px;
    max-width: calc(100% - 130px);

    @media (min-width: 1024px) {
      font-size: 35px;
    }
  }

  .hotel-rating-component {
    min-width: 130px;
    shrink: 0;
  }

  .section {
    + .section {
      border-top: 1px solid #979797;
      padding-top: 1rem;
      padding-bottom: 1rem;

      &.last-child {
        padding-bottom: none;
      }
    }

    p {
      color: black;
      line-height: 1.5;
    }
  }

  .facilities {
    column-count: 2;
    column-gap: 3rem;
    > p {
      line-height: 1.2;
    }
  }

  .map-container {
    margin-bottom: 1.5rem;
    width: 100%;
    height: 0;
    padding-top: 48%;
    position: relative;
    border-radius: 15px;

    @media (min-width: 500px) {
      width: 479px;
      height: 250px;
      padding-top: 0;
    }
    @media (min-width: 1024px) {
      margin-bottom: 0;
      padding-top: 30%;
      width: 50%;
    }
  }
}
</style>
